// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');

// Special API URL for conversational prescreening (use environment variable)
export const CONVERSATIONAL_API_BASE_URL = process.env.REACT_APP_CONVERSATIONAL_API_URL || (window.location.origin + '/api');

// Debug: Log the API base URL to see what's being used
console.log('API_BASE_URL:', API_BASE_URL);
console.log('REACT_APP_API_URL env var:', process.env.REACT_APP_API_URL);
console.log('CONVERSATIONAL_API_BASE_URL:', CONVERSATIONAL_API_BASE_URL);

// File Upload Configuration
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
export const ALLOWED_FILE_TYPES = [
  'application/pdf',
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
];

// Pagination Configuration
export const DEFAULT_PAGE_SIZE = 8;
export const DEFAULT_PAGE = 1;

// Toast Duration
export const TOAST_DURATION = 3000; // 3 seconds

// Local Storage Keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER_DATA: 'user_data'
};
